import { PageProps } from '../../../src/components/Page';
import AdditionalScripts from './AdditionalScripts';
import { ChartbeatAnalyticsV2 } from './ChartbeatAnalyticsV2';

export default function RootScripts({ pageProps }: { pageProps?: PageProps }) {
  return (
    <>
      <ChartbeatAnalyticsV2 pageProps={pageProps} />
      <AdditionalScripts
        pageProps={{
          embeddedWidget: pageProps?.embeddedWidget,
          disablePushPrompt: pageProps?.disablePushPrompt ?? true,
        }}
      />
    </>
  );
}
